import { types } from 'mobx-state-tree';

const ProductFeature = types.model('ProductFeature', {
  id: types.number,
  name: types.string
});

export default ProductFeature;
